import _prop from "ramda/es/prop";
import _compose from "ramda/es/compose";
import snsEvent from './snsEvent';
export default _compose(_prop('Subject'), snsEvent);